import { Field, useFormikContext } from 'formik';
import React from 'react';
import { Grid } from '@mui/material';
import {
  AutoCompleteSelectUI,
  DateTimePickerUI,
  FormErrorUI,
  FormLabelUI,
  InputUI,
  SelectUI,
} from '../../../Interface';
import { CRMEventTypeList } from '../../../../config/CRMEventType';
import dayjs from 'dayjs';

const CrmDialogFields = ({ autoCompleteOptions }) => {
  const { errors, validateField, setFieldValue, values } = useFormikContext();

  const updateDuration = (startDate, endDate) => {
    const duration = dayjs(endDate).diff(dayjs(startDate), 'hour', true);

    setFieldValue('duration', duration);
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Field
          type="text"
          name="name"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Esemény megnevezése" />}
          helperText={<FormErrorUI message={errors.name} />}
          InputLabelProps={{ shrink: values.name !== '' }}
          multiline
          rows={2}
        />
      </Grid>
      <Grid item xs={6}>
        <Field
          type="date"
          name="startDate"
          component={DateTimePickerUI}
          value={values.startDate}
          fullWidth
          label={<FormLabelUI text="Kezdő dátum" />}
          variant="outlined"
          size="small"
          helperText={<FormErrorUI message={errors.startDate} />}
          onChange={(date) => {
            setFieldValue('startDate', date).then(() => {
              validateField('startDate');
            });

            updateDuration(date, values.endDate);
          }}
          InputLabelProps={{ shrink: values.startDate !== '' }}
        />
      </Grid>

      <Grid item xs={6}>
        <Field
          type="date"
          name="endDate"
          component={DateTimePickerUI}
          value={values.endDate}
          fullWidth
          label={<FormLabelUI text="Befejező dátum" />}
          variant="outlined"
          size="small"
          helperText={<FormErrorUI message={errors.endDate} />}
          onChange={(date) => {
            setFieldValue('endDate', date).then(() => {
              validateField('endDate');
            });

            updateDuration(values.startDate, date);
          }}
          InputLabelProps={{ shrink: values.endDate !== '' }}
        />
      </Grid>

      <Grid item xs={6}>
        <Field
          type="autocomplete"
          name="typeId"
          component={AutoCompleteSelectUI}
          fullWidth
          label={<FormLabelUI text="Esemény típusa" />}
          variant="outlined"
          size="small"
          helperText={<FormErrorUI message={errors.typeId} />}
          onChange={(_e, newVal) => {
            setFieldValue('typeId', newVal?.value ?? null).then(() => {
              validateField('typeId');
            });
          }}
          InputLabelProps={{ shrink: values.typeId !== '' }}
          selectedValue={values.typeId}
          dataset={autoCompleteOptions.crmTaskType}
        />
      </Grid>
      <Grid item xs={6}>
        <Field
          name="eventType"
          component={SelectUI}
          fullWidth
          label={<FormLabelUI text="Esemény fajtája" />}
          variant="outlined"
          size="small"
          helperText={<FormErrorUI message={errors.eventType} />}
          onChange={(e) => {
            const value = e.target.value;
            setFieldValue('eventType', value ?? null).then(() => {
              validateField('eventType');
            });
          }}
          value={values.eventType ?? ''}
          option={CRMEventTypeList}
        />
      </Grid>
    </Grid>
  );
};

export default CrmDialogFields;
